import React from "react";
import { Sparkle } from "@phosphor-icons/react";

export default function PlaceholderPage({ title, hint }) {
  return (
    <div className="p-8 lg:p-12" data-testid={`admin-placeholder-${title.toLowerCase()}`}>
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-2">
          Contenuti
        </div>
        <h1 className="font-serif text-4xl lg:text-5xl leading-tight">{title}</h1>
      </header>

      <div className="border border-white/10 bg-white/[0.02] p-12 text-center">
        <Sparkle size={28} weight="light" className="mx-auto text-[#C5A059] mb-4" />
        <div className="font-serif text-2xl mb-3">Editor in arrivo</div>
        <p className="text-white/50 text-sm max-w-md mx-auto">
          {hint ||
            "Questa sezione avrà un editor bilingue completo (italiano ed inglese) per creare, modificare e pubblicare contenuti direttamente dal pannello di amministrazione."}
        </p>
        <div className="text-xs text-white/30 mt-6 uppercase tracking-[0.2em]">
          Prossima iterazione
        </div>
      </div>
    </div>
  );
}
